import React from 'react';
import { resolveDimensionLabel } from '../constants/dimensionLabels';

const LEVEL_LABEL = { high: '关注度高', medium: '关注度中', low: '关注度低' };

export default function InsightWallPanel({ insights }) {
  if (!insights) return null;
  const items = insights.items || [];

  return (
    <div className="insight-wall">
      <div className="insight-wall-header">
        <span className={`attention-badge level-${insights.attention_level || 'low'}`}>
          {LEVEL_LABEL[insights.attention_level] || '关注度低'}
        </span>
      </div>
      {!items.length ? (
        <p className="decision-muted">暂无结构化洞察</p>
      ) : (
        <ul className="insight-list">
          {items.map((item, idx) => (
            <li className={`insight-item severity-${item.severity}`} key={`${item.dimension}-${idx}`}>
              <span className="insight-dim" title={item.dimension}>
                {item.dimension_label || resolveDimensionLabel(item.dimension)}
              </span>
              <span className="insight-text">{item.text}</span>
            </li>
          ))}
        </ul>
      )}
      {insights.decision_hint ? (
        <p className="insight-hint">{insights.decision_hint}</p>
      ) : null}
    </div>
  );
}
